import * as React from 'react';
import { IgcHighlightComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * The highlight component provides efficient searching and highlighting of text
 * projected into it via its default slot. It uses the native CSS Custom Highlight API
 * to apply highlight styles to matched text nodes without modifying the DOM.
 *
 * The component supports case-sensitive matching, programmatic navigation between
 * matches, and automatic scroll-into-view of the active match.
 * @slot  - The default slot. Place the text content you want to search and highlight here.
 * @cssproperty --foreground - The text color for a highlighted text node.
 * @cssproperty --background - The background color for a highlighted text node.
 * @cssproperty --foreground-active - The text color for the active highlighted text node.
 * @cssproperty --background-active - The background color for the active highlighted text node.
 * @class
 */
export const IgrHighlight = /* @__PURE__ */ createComponent({
  tagName: 'igc-highlight',
  displayName: 'IgrHighlight',
  elementClass: Component,
  react: React,
});

export type IgrHighlight = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrHighlightModule = Component;
